<template>
  <div id="page-product-edit">
    <vs-row class="mb-5">
      <!-- start::column title and breacrumbs -->
      <vs-col vs-type="flex" vs-align="center" vs-w="8">
        <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
          <h2 class="mb-1">
            {{ pageTitle }}
          </h2>
        </div>
        <div class="vx-breadcrumb ml-4 md:block hidden">
          <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
              <a href="/" class="router-link-active">
                <span class="feather-icon select-none relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-home h-5 w-5 mb-1 stroke-current text-primary">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </span>
              </a>
              <span class="breadcrumb-separator mx-2">
                <span class="feather-icon select-none relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevrons-right w-4 h-4">
                    <polyline points="13 17 18 12 13 7"></polyline>
                    <polyline points="6 17 11 12 6 7"></polyline>
                  </svg>
                </span>
              </span>
            </li>
            <li class="inline-flex items-center">
              <a href="/products/list" class="">Προϊόντα</a>
              <span class="breadcrumb-separator mx-2 flex items-start">
                <span class="feather-icon select-none relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevrons-right w-4 h-4">
                    <polyline points="13 17 18 12 13 7"></polyline>
                    <polyline points="6 17 11 12 6 7"></polyline>
                  </svg>
                </span>
              </span>
            </li>
            <li class="inline-flex">
              <span class="cursor-default" v-if="!item.id">Προσθήκη νέου προϊόντος</span>
              <span class="cursor-default" v-if="item.id">{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </vs-col>
      <!-- end::column title and breacrumbs -->

      <!-- start::column return back -->
      <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-w="4">
        <button class="vs-button ml-auto mb-2 vs-button-primary favouriteItem" @click="toggleFavourite" :class="{ active: is_favourite }">
          <vs-icon size="medium" icon-pack="feather" icon="icon-star" :class="{ active: is_favourite }"/>
        </button>
        <vs-button @click="$router.push('/products/list')" color="primary" type="filled" icon="undo"
          class="ml-1 mb-2">
          Επιστροφή
        </vs-button>
      </vs-col>
      <!-- end::column return back -->

    </vs-row>
    <!-- end::top row -->

    <!-- start::card -->
    <div class="vx-card p-6">

      <!-- Content Row -->
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">

            <vs-tabs>
              <vs-tab label="Γενικά" icon-pack="feather" icon="icon-home">
                <!-- start::form -->
                <validation-observer ref="productObserver" v-slot="{invalid}">
                  <div class="vx-row">
                    <div class="vx-col md:w-2/3 w-full">
                      <validation-provider rules="required" v-slot="{errors}">
                        <vs-input class="w-full mt-4" label="Κωδικός*" name="part_number" v-model="part_number" />
                        <div class="text-right text-danger">{{ errors[0] }}</div>
                      </validation-provider>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                      <br>
                      <span>Ενεργό</span>
                      <vs-switch v-model="checked" />
                    </div>
                  </div>
                  <!-- start::title -->
                  <validation-provider rules="required" v-slot="{errors}">
                    <vs-input class="w-full mt-4" label="Τίτλος*" name="name" v-model="name" />
                    <div class="text-right text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                  <!-- end::title -->
                  <vs-input class="w-full mt-4" label="Κατασκευαστής" v-model="manufacturer" />
                  <div class="mt-4">
                    <label class="vs-input--label">Κατηγορία</label>
                    <v-select v-model="categoryId" :reduce="category => category.id" label="name" :clearable="false"
                              :options="categories" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  </div>
                  <vs-input class="w-full mt-4" label="Υποκατηγορία" v-model="group" />
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full">
                      <validation-provider rules="double" v-slot="{errors}">
                        <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-right vs-input-primary">
                          <label class="vs-input--label">Τιμή κόστους</label>
                          <div class="vs-con-input">
                            <currency-input
                                v-model="cost_price" class="vs-inputx vs-input--input normal hasValue" style="text-align: right; border: 1px solid rgba(0, 0, 0, 0.2);"
                                currency="EUR"
                                locale="el"
                            />
                            <div class="text-right text-danger">{{ errors[0] }}</div>
                          </div>
                        </div>
                      </validation-provider>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-right vs-input-primary">
                        <label class="vs-input--label">Τιμή ασφαλείας</label>
                        <div class="vs-con-input">
                          <currency-input
                              v-model="safe_price" class="vs-inputx vs-input--input normal hasValue" style="text-align: right; border: 1px solid rgba(0, 0, 0, 0.2);"
                              currency="EUR"
                              locale="el"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <validation-provider rules="required|double|min_value:1" v-slot="{errors}">
                        <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-right vs-input-primary">
                          <label class="vs-input--label">Ενδεικτική τιμή*</label>
                          <div class="vs-con-input">
                            <currency-input
                                v-model="erp_price" class="vs-inputx vs-input--input normal hasValue" style="text-align: right; border: 1px solid rgba(0, 0, 0, 0.2);"
                                currency="EUR"
                                locale="el"
                            />
                            <div class="text-right text-danger">{{ errors[0] }}</div>
                          </div>
                        </div>
                        <div class="text-right text-danger">{{ errors[0] }}</div>
                      </validation-provider>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <validation-provider rules="double" v-slot="{errors}">
                        <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-right vs-input-primary">
                          <label class="vs-input--label">Τιμή με έκπτωση*</label>
                          <div class="vs-con-input">
                            <currency-input
                                v-model="promo_price" class="vs-inputx vs-input--input normal hasValue" style="text-align: right; border: 1px solid rgba(0, 0, 0, 0.2);"
                                currency="EUR"
                                locale="el"
                            />
                            <div class="text-right text-danger">{{ errors[0] }}</div>
                          </div>
                        </div>
                        <div class="text-right text-danger">{{ errors[0] }}</div>
                      </validation-provider>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-right vs-input-primary">
                        <span>Έχει απόθεμα</span>
                        <vs-switch style="margin-left: auto;" v-model="has_stock" />
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-right vs-input-primary">
                        <vs-input class="w-full mt-4" label="Απόθεμα" v-model="stock" />
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-right vs-input-primary">
                        <vs-input class="w-full mt-4" label="Remote Id" v-model="remoteId" />
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-right vs-input-primary">
                        <vs-input class="w-full mt-4" label="Barcode" v-model="barcode" />
                      </div>
                    </div>
                  </div>
                </validation-observer>
                <!-- end::form -->
              </vs-tab>
              <vs-tab label="Λεπτομέρειες" icon-pack="feather" icon="icon-box">
                <div class="vx-col md:w-2/2 w-full">
                  <div class="vs-component vs-con-input-label vs-input w-full mt-4 text-left vs-input-primary">
                    <label>Περιγραφή</label>
                    <quill-editor v-model="description">{{description}}</quill-editor>
                  </div>
                </div>
                <vs-divider style="margin-top: 40px;"><b>Φωτογραφίες</b></vs-divider>
                <div class="vx-col md:w-2/2 w-full">
                  <div class="image-preview-container">
                    <div v-for="url in image" :key="url" class="image-thumbnail">
                      <img :src="url" alt="Thumbnail" style="width:80px;" />
                    </div>
                  </div>

                  <vs-upload
                      multiple
                      text="Ανέβασμα πολλαπλών φωτογραφιών"
                      limit="5"
                      :data="image"
                      :action="uploadAction"
                      :headers="uploadHeaders"
                      @on-success="successUpload"
                      fileName="files"
                  />
                </div>
              </vs-tab>
            </vs-tabs>
        </div>

        <div class="vx-col md:w-2/3 w-full">
          <div class="mt-4">
            <vx-card card-background="#fafafa" style="min-height:420px;">
              <div class="vx-row ">
                <div class="vx-col w-1/2">
                  <h4 class="text-primary mb-2">Λίστα με διευθύνσεις για έλεγχο</h4>
                  <h6 class="text-dark">Μπορείτε να προσθέσετε όσες επιθυμείτε</h6>
                </div>
                <div class="vx-col text-right w-1/2">
<!--                  :disabled="pageTitle === 'Νέα εγγραφή'"-->
                  <vs-button color="success" type="filled" @click="addMore()">
                    ΠΡΟΣΘΗΚΗ
                  </vs-button>
                </div>
              </div>
              <vs-divider />
              <div style="max-height:520px;height:520px;overflow-y:scroll">
                <div class="vx-row mb-2" v-for="(item, index) in links">
                  <div class="vx-col w-3/12">
                    <label class="vs-input--label">Ιστοσελίδα</label>
                    <v-select v-model="item.eshop" value="id" label="name" :clearable="false" :options="eshops" append-to-body
                      :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  </div>
                  <div class="vx-col w-4/12">
                    <vs-input class="w-full bg-transparent" label="Link" v-model="item.eshopURL" />
                  </div>
                  <div class="vx-col w-2/12" style="text-align: right">
                    <label class="vs-input--label">Διαφορά</label>
                    <currency-input
                        v-model="item.defferenece" class="vs-inputx vs-input--input normal hasValue" style="text-align: right; border: 1px solid rgba(0, 0, 0, 0.2);"
                        currency="EUR"
                        locale="el"
                    />
                  </div>
                  <div class="vx-col w-2/12">
                    <vs-input class="w-full bg-transparent" label="Ποσοστό" v-model="item.percentage" style="text-align: right" />
                  </div>
                  <div class="vx-col w-1/12">
                    <vs-button color="danger" type="border" @click="removeElement(index)" icon-pack="feather"
                      icon="icon-trash" size="medium" class="mt-6  sm:mr-0"></vs-button>
                  </div>

                  <div class="vx-col w-11/12 mt-2">
                    <div class="card-body">
                      <ul class="list-unstyled mb-0">
                        <li class="d-inline-block" style="display: inline-block;">
                          <vs-radio v-model="item.dprules" vs-name="dprules" vs-value="none">None</vs-radio>
                        </li>
                        <li class="d-inline-block mr-2" style="display: inline-block;">
                          <vs-radio v-model="item.dprules" vs-name="dprules" vs-value="choosenSkroutz">Επιλεγμένο Κατάστημα</vs-radio>
                        </li>
                        <li class="d-inline-block mr-2" style="display: inline-block;">
                          <vs-radio v-model="item.dprules" vs-name="dprules" vs-value="fbs">FBS</vs-radio>
                        </li>
                        <li class="d-inline-block mr-2" style="display: inline-block;">
                          <vs-radio v-model="item.dprules" vs-name="dprules" vs-value="proseller">Pro Seller</vs-radio>
                        </li>
                        <li class="d-inline-block mr-2" style="display: inline-block;">
                          <vs-radio v-model="item.dprules" vs-name="dprules" vs-value="marketplace">Marketplace</vs-radio>
                        </li>
                        <li class="d-inline-block mr-2" style="display: inline-block;">
                          <vs-radio v-model="item.dprules" vs-name="dprules" vs-value="express">Express Delivery</vs-radio>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>

          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-4 mt-2" @click.prevent="addRecord">Αποθήκευση</vs-button>
          </div>
        </div>
      </div>
    </div>
    <!-- end::card -->
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from 'vue-select'
import VueRepeater from 'vue-repeater'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// Validation
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, double, min_value } from 'vee-validate/dist/rules'
import VueCurrencyInput from 'vue-currency-input'
const pluginOptions = {
  /* see config reference */
  globalOptions: {currency: 'EUR'}
}
Vue.use(VueCurrencyInput, pluginOptions)
extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο',
})

extend('double', {
  ...double,
  message: 'Πληκτρολογείστε ένα δεκαδικό αριθμό διαχωρισμένο με (.) τελεία.',
})

extend('min_value', {
  ...min_value,
  message: 'Η τιμή θα πρέπει να είναι μεγαλύτερη από 1.',
})

export default {
  components: {
    vSelect,
    'vue-repeater': VueRepeater,
    ValidationObserver,
    ValidationProvider,
    VueCurrencyInput,
    quillEditor
  },
  name: 'product-edit',
  data() {
    return {
      radios1:'',
      initiated: false,
      productLink: { eshopId: null, eshopURL: '' },
      links: [],
      uploadedImages: []
    }
  },
  computed: {
    // Page title
    pageTitle() {
      return this.$store.getters.getProductPageCaption
    },
    // The product
    item() {
      return this.$store.getters.getProduct
    },
    // Getter and setter for part_number
    part_number: {
      get() {
        return this.item.part_number
      },
      set(value) {
        this.$store.dispatch('setProductPartNumber', value)
      },
    },
    // Getter and setter for checked
    checked: {
      get() {
        return this.item.checked
      },
      set(value) {
        this.$store.dispatch('setProductChecked', value)
      },
    },
    // Getter and setter for name
    name: {
      get() {
        return this.item.name
      },
      set(value) {
        this.$store.dispatch('setProductName', value)
      },
    },
    // Getter and setter for manufacturer
    manufacturer: {
      get() {
        return this.item.manufacturer
      },
      set(value) {
        this.$store.dispatch('setProductManufacturer', value)
      },
    },
    group: {
      get() {
        return this.item.group
      },
      set(value) {
        this.$store.dispatch('setProductGroup', value)
      },
    },
    description: {
      get() {
        return this.item.description
      },
      set(value) {
        this.$store.dispatch('setProductDescription', value)
      },
    },
    // Getter and setter for erp_price
    erp_price: {
      get() {
        return this.item.erp_price
      },
      set(value) {
        this.$store.dispatch('setProductErpPrice', value)
      },
    },
    // Getter and setter for safe_price
    safe_price: {
      get() {
        return this.item.safe_price
      },
      set(value) {
        this.$store.dispatch('setProductSafePrice', value)
      },
    },

    // Getter and setter for promo_price
    promo_price: {
      get() {
        return this.item.promo_price
      },
      set(value) {
        this.$store.dispatch('setProductPromoPrice', value)
      },
    },
    cost_price: {
      get() {
        return this.item.cost_price
      },
      set(value) {
        this.$store.dispatch('setProductCostPrice', value)
      },
    },
    // Getter and setter for categoryId
    categoryId: {
      get() {
        return this.item.categoryId
      },
      set(value) {
        this.$store.dispatch('setProductCategoryId', value)
      },
    },
    // Product categories
    categories() {
      return this.$store.getters.getSettingCategories
    },
    // E-Shops
    eshops() {
      return this.$store.getters.getShops
    },
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        }
      },
      set(obj) {
        this.data_local.status = obj.value
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        }
      },
      set(obj) {
        this.data_local.role = obj.value
      },
    },
    // Getter and setter for barcode
    barcode: {
      get() {
        return this.item.barcode
      },
      set(value) {
        this.$store.dispatch('setProductBarcode', value)
      },
    },
    // Getter and setter for stock
    stock: {
      get() {
        return this.item.stock
      },
      set(value) {
        this.$store.dispatch('setProductStock', value)
      },
    },
    // Getter and setter for remoteId
    remoteId: {
      get() {
        return this.item.remoteId
      },
      set(value) {
        this.$store.dispatch('setProductRemoteId', value)
      },
    },
    // Getter and setter for has_stock
    has_stock: {
      get() {
        return this.item.has_stock
      },
      set(value) {
        this.$store.dispatch('setProductHasStock', value)
      },
    },
    image: {
      get() {
        try {
          return JSON.parse(this.item.image);
        } catch (error) {
          console.error('Error parsing JSON:', error);
          return null; // or return a default value or an empty object {} as you see fit
        }
      },
      set(value) {
        this.$store.dispatch('setProductImage', value);
      },
    },
    is_favourite: {
      get() {
        return this.item.is_favourite
      },
      set(value) {
        this.$store.dispatch('setProductFavourite', value)
      },
    },
    uploadAction() {
      return localStorage.getItem('apiEndpoint') + 'product/add-images'
    },
    uploadHeaders() {
      return { 'Authorization': `Bearer ${localStorage.getItem('accessToken')}` }
    }
  },
  methods: {
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    addMore() {
      let payload = { eshopId: null, eshopURL: '', defferenece: 0, percentage: 0, dprules: '' }
      this.links.push(payload)
    },
    removeElement: function (index) {
      let vm = this
      this.links.splice(index, 1)
    },
    save_changes() {
      console.log('Save Changes Implementation here!!')
    },
    // Reset new product form
    reset_data() {
      const product = {
        part_number: '',
        checked: false,
        name: '',
        manufacturer: '',
        erp_price: 0.0,
        promo_price: 0.0,
        safe_price: 0.0,
        categoryId: null,
        has_stock: false,
        stock: null,
        remoteId: null,
        barcode: '',
        is_favourite: false,
      }
      this.$store.dispatch('setProduct', product)
      this.uploadedImages = []
    },

    // This method must be async because:
    // 1. The add button is outside the form so we must validate it in code.
    // 2. Validate method of validation observer is a Promise
    async addRecord() {
      this.$store.dispatch('setProductLink', this.links)

      if (this.uploadedImages && this.uploadedImages.length > 0) {
        this.$store.dispatch('setProductImage', this.uploadedImages)
      }
      // Validate the product
      // const valid = await this.$refs.productObserver.validate()
      // // Id not valid (false), inform the user
      // if (!valid) {
      //   this.$vs.notify({
      //     color: 'danger',
      //     title: 'Λάθος στον έλέγχο πεδίων',
      //     position: 'top-right',
      //     text: 'Παρακαλώ συμπληρώστε όλα τα πεδία με * και τουλάχιστον 1 διεύθυνση για έλεγχο.',
      //   })
      // }
      // // Proceed to add or update product.
      // else {
        // item.id exists update product
        if (this.item.id) {
          this.$store.dispatch('updateProduct', this.item).then((response) => {
            if (response.message === 'Successfully Updated') {
              this.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })

              this.$router.replace({ name: 'products-list' })
            } else {
              this.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
            }
          })
        }
        else {
          this.$store.dispatch('addProduct', this.item).then((response) => {
            if (response.error === false) {
              this.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })

              this.$router.replace({ name: 'products-list' })

              //this.$router.push({
              //  name: 'products-edit',
              //  params: { id: response.object.id },
              //})

              //this.$store.dispatch(
              //  'setProductPageCation',
              //  `Επεξεργασία εγγραφής ${response.object.name}`
              //)


            } else {
              this.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
            }
          })
        }
      //}
    },
    toggleFavourite() {
      this.$store.dispatch('setProductFavourite', !this.is_favourite)
    },
    successUpload(response) {
      let path = JSON.parse(response.currentTarget.response).original.paths
      path = path.replace('/home/runcloud/webapps/IntelliPrice/public','')
      this.uploadedImages.push(path);
    },
    handleError(error) {
      console.error('Upload Error:', error);
    },
    handleFail(response) {
      console.error('Upload Failed:', response);
    },
  },
  mounted() {
    this.$store.dispatch('fetchShops')
    this.$store.dispatch('fetchSettingCategories')
    if (this.$route.params.id) {
      this.$store.dispatch('fetchProduct', this.$route.params.id).then(() => {
        this.links = JSON.parse(JSON.stringify(this.$store.getters.getProduct.links))
      })
    } else {
      const product = {
        part_number: '',
        checked: false,
        name: '',
        manufacturer: '',
        erp_price: 0.0,
        promo_price: 0.0,
        cost_price: 0.0,
        safe_price: 0.0,
        categoryId: null,
        has_stock: false,
        stock: null,
        remoteId: null,
        barcode: '',
        is_favourite: false,
      }
      this.$store.dispatch('setProduct', product)
    }
  },
}
</script>

<style scoped>
.favouriteItem {
  background: none !important;
}
.favouriteItem i.icon-star {
  color: #7e7963 !important;
  font-size: 26px !important;
}
.favouriteItem i.icon-star.active {
  color: #fdcc0d !important;
}

.image-preview-container {
   display: flex;
   flex-wrap: wrap;
 }

.image-thumbnail {
  width: 100px; /* Or whatever size you prefer */
  height: 100px; /* Maintain aspect ratio */
  margin: 5px;
  overflow: hidden; /* To handle images not fitting the container */
  position: relative; /* To position images center */
  border: 1px solid #ccc;
  box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);
}

.image-thumbnail img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

<style>
.con-img-upload {
  padding: 0.4rem;
}

.con-input-upload {
  margin: 0;
}
</style>
